import { CommonModule } from "@angular/common";
import { Component, ElementRef, Input, ViewChild, inject } from "@angular/core";
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  ValidatorFn,
  Validators,
} from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatDialog } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { Store, select } from "@ngrx/store";
import { distinctUntilChanged, firstValueFrom, Observable } from "rxjs";
import { AppState } from "../../../app.state";
import { ConfirmDialogComponent } from "../../../confirm-dialog/confirm-dialog.component";
import {
  IAcuerdo,
  IAcuerdoSeleccionado,
  IArchivoAcuerdo,
} from "../../../interfaces/acuerdos";
import { IDetalleTema, stateDetalleTema } from "../../../interfaces/temas";
import { LoadingService } from "../../../loading/loading.service";
import { StorageService } from "../../../services/storage/files.service";
import { expandAcuerdo } from "../../../states/acuerdos-mrb/actions";
import { selectAllAcuerdos } from "../../../states/acuerdos-mrb/selector";
import {
  cancelarFormulariosAcuerdo,
  guardarFormulariosAcuerdo,
} from "../../../states/forms/actions";
import {
  agregarEditarObservacionesAcuerdo,
  realizarAcuerdo,
  resetTemasAcuerdo,
} from "../../../states/temas/actions";
import {
  selectAcuerdoSelected,
  selectAcuerdoTemas,
} from "../../../states/temas/selectors";
import * as moment from "moment";
import { AcuerdosUtilsService } from "../utils";
import { selectUsuario } from "../../../states/usuario/selector";
import { AcuerdoMrbService } from "../../../acuerdo-mrb/acuerdo-mrb.service";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
@Component({
  selector: "app-nuevo-tema",
  standalone: true,
  imports: [
    MatIconModule,
    MatButtonModule,
    MatSlideToggleModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
  ],
  templateUrl: "./nuevo-tema.component.html",
  styleUrl: "./nuevo-tema.component.css",
})
export class NuevoTemaComponent {
  @Input() acuerdo!: FormGroup;
  @Input() temasAcuerdo!: FormGroup;

  private readonly store: Store<AppState> = inject(Store);
  temas$!: Observable<IDetalleTema[]>;
  files: IArchivoAcuerdo[] = [];
  public indexTemas: number = 0;

  temas: IDetalleTema[] = [];
  detalleTema!: FormGroup;
  acuerdoSeleccionado$!: Observable<IAcuerdoSeleccionado>;
  acuerdoActual!: IAcuerdo;
  @ViewChild("fileInput") fileInput!: ElementRef;
  private readonly stateTipoAcuerdo: any = this.store.pipe(
    select(selectAllAcuerdos)
  );

  private stateUser: any = this.store.pipe(select(selectUsuario));
  public disabled!: boolean;
  public catTipoTema: any[] = [];
  public catCategorizacion: any[] = [];
  private acuerdoMrbService = inject(AcuerdoMrbService);
  constructor(
    private fb: FormBuilder,
    private storageService: StorageService,
    public dialog: MatDialog,
    private loadingService: LoadingService,
    private utils: AcuerdosUtilsService,
    private sanitizer: DomSanitizer
  ) {
   

    this.temas$ = this.store.pipe(select(selectAcuerdoTemas));

    this.temas$.subscribe((data) => {
      this.temas = data;
    });

    this.detalleTema = this.fb.group({
      esRealizado: [false, [Validators.required]],
      observaciones: [
        {
          value: "",
          disabled: this.disabled,
        },
      ],
    });
  }

  async ngOnInit() {
     this.loadingService.show();
 

    this.detalleTema = this.fb.group({
      esRealizado: [
        this.acuerdo.value.esRealizado ?? false,
        [Validators.required],
      ],
      observaciones: [
        {
          value: this.acuerdo.value.observaciones ?? "",
          disabled: this.disabled,
        },
      ],
    });

    this.catTipoTema = await firstValueFrom(
      this.acuerdoMrbService.getCatalogo(this.acuerdoMrbService.cats.TIPO_TEMA)
    );
    this.catCategorizacion = await firstValueFrom(
      this.acuerdoMrbService.getCatalogo(
        this.acuerdoMrbService.cats.CATEGORIZACION
      )
    );

    this.disabled =
      structuredClone(this.stateTipoAcuerdo.state().acuerdosMRB.tipoAcuerdo) ===
      3
        ? true
        : false;
    this.acuerdoSeleccionado$ = this.store.select(selectAcuerdoSelected);
    this.acuerdoSeleccionado$
      .pipe(
        distinctUntilChanged(
          (prev, curr) => prev.acuerdo.idFE === curr.acuerdo.idFE
        )
      )
      .subscribe((data) => {
        this.acuerdoActual = data.acuerdo;
         

        if (
          this.acuerdoActual.idFE !== "" &&
          this.acuerdoActual.idFE === data.acuerdo.idFE
        ) {
          this.createForm();
        }
      });

    this.detalleTema.get("observaciones")?.valueChanges.subscribe((value) => {
      this.acuerdo.get("observaciones")?.setValue(value);
    });

    this.detalleTema.get("esRealizado")?.valueChanges.subscribe((value) => {
      console.log("esRealizado", value);
      this.acuerdo.get("esRealizado")?.setValue(value);
    });
  }
  async createForm() {
      this.loadingService.show()
      const archivosAcuerdo = await firstValueFrom(
        this.storageService.obtenerArchivos(this.acuerdo.value.idFE)
      );
      const archivos = archivosAcuerdo.error ? [] : archivosAcuerdo.archivos;
      this.files = archivos;
      this.detalleTema = this.fb.group({
        esRealizado: [this.acuerdoActual.esRealizado, [Validators.required]],
        observaciones: [
          {
            value: this.acuerdoActual.observaciones ?? "",
            disabled: this.disabled,
          },
        ],
        fechaAcuerdo: [this.acuerdoActual.fechaAcuerdo],
        idAcuerdo: [this.acuerdoActual.idFE],
      });
      this.loadingService.hide();
  }

  addNuevoTema(event: any) {
    const indiceTema = this.getMaxIndiceTema() + this.indexTemas;
    const nuevoTema: IDetalleTema = {
      ...stateDetalleTema,
      id: "",
      indiceTema: indiceTema,
      fechaAcuerdo: this.acuerdoActual.fechaAcuerdo,
      nuevoTema: true,
      idAcuerdo: this.acuerdoActual.idFE,
    };

    const newTemasArray = [
      ...this.temasAcuerdoArray.controls,
      this.newForm(nuevoTema),
    ];

    // Set the new FormArray to the 'temas' control
    this.temasAcuerdo.setControl("temas", this.fb.array(newTemasArray));
    this.indexTemas += 1;
  }

  newForm(tema: IDetalleTema): FormGroup {
    const user = this.stateUser.state().usuario;
    return this.fb.group({
      idTema: [tema.id],
      nombreTema: [
        {
          value: tema.nombreTema,
          disabled:
            (!this.utils.getPermisoEscritura(tema.categorizacion) &&
              !tema.nuevoTema) ||
            this.utils.esHistorico(),
        },
        [this.requiredWhenTouchedValidator()],
      ],
      descripcionTema_html: [
        {
          value: tema.descripcionTema_html,
          disabled:
            (!this.utils.getPermisoEscritura(tema.categorizacion) &&
              !tema.nuevoTema) ||
            this.utils.esHistorico(),
        },
        [Validators.required],
      ],
      accion: [
        {
          value: "",
          disabled:
            !this.utils.getEsResponsable(tema) || this.utils.esHistorico(),
        },
      ],
      respAnalista: [
        {
          value: tema.respAnalista,
          disabled: this.utils.esResponsableNuevoTema(tema),
        },
        [this.requiredWhenTouchedValidator()],
      ],
      respCoordinador: [
        {
          value: tema.respCoordinador,
          disabled: this.utils.esResponsableNuevoTema(tema),
        },
        [this.requiredWhenTouchedValidator()],
      ],
      respSupervisor: [
        {
          value: tema.respSupervisor,
          disabled: this.utils.esResponsableNuevoTema(tema),
        },
        [this.requiredWhenTouchedValidator()],
      ],
      esAprobado: [
        {
          value: tema.esAprobado,
          disabled: this.utils.esResponsableNuevoTema(tema),
        },
        [Validators.required],
      ],
      tipoTema: [
        {
          value: this.utils.getDefaultTipoTema(tema.tipoTema, this.catTipoTema),
          disabled: this.utils.esResponsableNuevoTema(tema),
        },
        [this.requiredWhenTouchedValidator()],
      ],
      esConfidencial: [
        {
          value: tema.esConfidencial,
          // disabled: this.utils.esResponsableNuevoTema(tema),--validar esResponsableNuevoTema
          disabled: !this.utils.enabledConfidencial(this.catCategorizacion),
        },
        [Validators.required],
      ],
      id_categoria: [
        {
          value: tema.nuevoTema ? null : tema.id_categoria,
          disabled: this.utils.esResponsableNuevoTema(tema),
        },
        [this.requiredWhenTouchedValidator()],
      ],
      categorizacion: [
        {
          value: this.utils.getDefaultCategorizacion(
            tema.categorizacion,
            this.catCategorizacion
          ),
          disabled: this.utils.esResponsableNuevoTema(tema),
        },
        [this.requiredWhenTouchedValidator()],
      ],
      esImpreso: [
        {
          value: tema.esImpreso,
          disabled: this.utils.esResponsableNuevoTema(tema),
        },
        [Validators.required],
      ],
      entradas: [tema.entradas],
      indiceTema: [tema.indiceTema],
      expanded: [tema.expanded],
      entradaSelected: [
        {
          value: "",
          disabled: this.utils.esHistorico() || !this.utils.puedeEditar(tema),
        },
      ],
      indicacion: [
        {
          value: "",
          disabled: tema.edoTema == 3 || !this.utils.puedeEditar(tema),
        },
        [this.requiredWhenTouchedValidator()],
      ],
      indicacionesAB: [tema.indicacionesAB, [Validators.required]],
      nuevoTema: [tema.nuevoTema],
      fechaAcuerdo: [tema.fechaAcuerdo],
      edoTema: [tema.edoTema],
      id: [tema.id],
      //parra nuevos temas obtener noommbre para
      nombreAnalista: [""],
      nombreSupervisor: [""],
      nombreCoordinador: [""],
      id_categorizacion: [
        this.utils.getDefaultCategorizacion(
          tema.categorizacion,
          this.catCategorizacion
        ),
      ],
      nombreUsuario: [user.nombre],
      //si no tiene persmisos desabilitar
      showDetalleTema: [this.utils.showTema(tema)],
      showConfidencial: [this.utils.showConfidencial(tema)],
      numEntregables: [this.utils.getNumeroEntregables(tema)],
      editorInstanceId: ["editorInstanceId-" + tema.indiceTema],
    });
  }

  requiredWhenTouchedValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      return control.dirty && !control.value
        ? { requiredWhenTouched: true }
        : null;
    };
  }

  get temasAcuerdoArray(): FormArray {
    return this.temasAcuerdo.get("temas") as FormArray;
  }

  get acuerdoMrb(): FormGroup {
    return this.temasAcuerdo.get("acuerdo") as FormGroup;
  }

  get esRealizado() {
    return this.acuerdoMrb.get("esRealizado");
  }

  getMaxIndiceTema(): number {
    return this.temas.length;
  }

  cancelarEdicion() {
    this.store.dispatch(expandAcuerdo({ idAcuerdo: this.acuerdoActual.idFE }));
    this.store.dispatch(resetTemasAcuerdo());
  }
  descargaBitacora() {
    this.loadingService.show();
    const fechaAcuerdo = this.formatToISOWithAdjustedTime(
      this.acuerdoActual.fechaAcuerdo
    );

    this.storageService
      .dowloadBitacora({
        idAcuerdo: this.acuerdoActual.idFE,
        fechaAcuerdo: fechaAcuerdo,
      })
      .subscribe((data) => {
        if (!data.error) {
          this.download(data.data);
        } else {
          this.loadingService.hide();
          this.showDialog(
            "Atención",
            "No se cuenta con observaciones para este acuerdo."
          );
        }
      });
  }

  download(data: BlobPart) {
    var blob = new Blob([data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    let fileName = `${this.parseDateSpanish(
      this.acuerdoActual.fechaAcuerdo
    )}.xlsx`;
    var link = document.createElement("a");

    link.id = "filexls";
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    link.click();

    this.loadingService.hide();
    // Revocar el objeto URL y eliminar el elemento por clase
    setTimeout(() => {
      window.URL.revokeObjectURL(link.href);
      const elements = document.getElementById("filexls");
      elements?.remove();
    }, 2000);
  }

  parseDateSpanish(dateString: string): string {
    moment.locale("es");
    const utcDate = moment.utc(dateString);
    const adjustedDate = utcDate.add(6, "hours");
    const localDate = adjustedDate.local();

    const formattedDate = localDate.format("D_MM_YYYY");
    const formattedTime = localDate.format("hh_mm_ss a"); // Ejemplo: "12_00_00 am"
    return `${formattedDate}, ${formattedTime}`;
  }

  formatToISOWithAdjustedTime(dateString: string): string {
    const utcDate = moment.utc(dateString);
    const adjustedDate = utcDate.hour(6).minute(0).second(0).millisecond(0);
    return adjustedDate.toISOString();
  }

  verArchivo(archivo: any) {
    window.open(archivo.url, "_blank");
  }

  cancelarGuardado() {
    this.loadingService.show();
    const temas = this.temasAcuerdo
      .getRawValue()
      .temas.filter((tema: any) => !tema.nuevoTema);
    this.store.dispatch(
      cancelarFormulariosAcuerdo({
        temas,
      })
    );
  }

  eliminarArchivo(archivo: IArchivoAcuerdo) {
    this.loadingService.show();
    if (archivo.nuevo) {
      this.files = this.files.filter((file) => file.fileId !== archivo.fileId);
      this.loadingService.hide();
    } else {
      this.storageService
        .eliminarArchivo(this.acuerdoActual.idFE, archivo.name)
        .subscribe((res) => {
          if (res) {
            this.files = this.files.filter(
              (file) => file.fileId !== archivo.fileId
            );
          }
          this.loadingService.hide();
        });
    }
  }

  seleccionarArchivos() {
    const fileInput = document.getElementById("fileInput") as HTMLInputElement;
    if (fileInput) {
      fileInput.click();
    }
  }

  subirArchivos(event: Event) {
    const input = event.target as HTMLInputElement;
    const files = input.files;

    if (files && files.length > 0) {
      let archivos_: IArchivoAcuerdo[] = [];
      let archivosDuplicados: string[] = [];

      archivos_ = Array.from(files)
        .map((file, index) => {
          const fileId = Number(Date.now()) + index;
          const archivoExiste = this.files.some(
            (archivo: IArchivoAcuerdo) => archivo.name === file.name
          );

          if (archivoExiste) {
            archivosDuplicados.push(file.name);
            return null;
          } else {
            return {
              name: file.name,
              ulr: "",
              nuevo: true,
              fileId,
              archivo: file,
            };
          }
        })
        .filter((file): file is IArchivoAcuerdo => file !== null);
      if (archivosDuplicados.length > 0) {
      const archivos = archivosDuplicados
        .map(
          (ar) =>
            `<span style="font-size: 12px; font-weight: 400; opacity:.5;">${ar}${
              archivosDuplicados.length > 0 ? ", " : " "
            }</span>`
        ).join("");

      const duplicados =
        "<div>" +
        "<p style='font-color:black'>" +
        `${
          archivosDuplicados.length === 1
            ? "El archivo " + archivos + " ya se encuentra seleccionado."
            : "Los archivos: " + archivos + " ya se encuentran seleccionados."
        }` +
        "</p>" +
        "</div>";
      const safeHtml: SafeHtml =
        this.sanitizer.bypassSecurityTrustHtml(duplicados);
        this.showDialog("", safeHtml);
      }

      if (archivos_.length > 0) {
        this.files = [...this.files, ...archivos_];
      }
    }
    input.value = "";
  }

  showDialog(title: string, message: any) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: "450px",
      data: {
        title,
        message,
        showButtons: {
          accept: true,
          cancel: false,
        },
        buttonsName: { cancel: "CANCELAR", accept: "ACEPTAR" },
        direction: "end",
      },
    });
  }

  dowloadFiles(files: IArchivoAcuerdo[]) {
    console.log("dowloadFiles", files);

    this.loadingService.show();
    const archivos: string[] = files
      .filter((file) => !file.nuevo)
      .map((file) => file.name);
    this.storageService
      .dowloadFiles({ acuerdo: this.acuerdoActual.idFE, archivos })
      .subscribe({
        next: (data) => {
          console.log("data", data);
          if (!data.error) {
            var link = document.createElement("a");
            link.href = data.data;
            link.setAttribute("id", "archivosZip");
            link.download = "archivos.zip";
            link.click();
            window.URL.revokeObjectURL(link.href);

            setTimeout(() => {
              const linkElement = document.getElementById("archivosZip");
              if (linkElement) {
                document.body.removeChild(linkElement);
              }
              this.loadingService.hide();
            }, 2000);
          }
        },
        error: (error) => {
          this.loadingService.hide();
          console.error("Error downloading files:", error);
        },
      });
  }
  seLlevoAcuerdo(event: any) {
    //console.log("event", event.checked);
    this.store.dispatch(realizarAcuerdo({ esRealizado: event.checked }));
  }

  updateObservaciones(observaciones: string) {
    // console.log("event", event.target.value);

    // if (event.key === "Enter") {
    //   event.preventDefault();
    //   return; // Previene la acción predeterminada (enviar formulario o salto de línea)
    // }

    // // Obtener el valor del input
    // const observaciones = this.detalleTema.get("observaciones")?.value ?? "";
    // console.log("observaciones", observaciones);

    //const observaciones = event?.target?.value ? event?.target?.value : "";
    //console.log("updateObservaciones", observaciones);

    this.store.dispatch(agregarEditarObservacionesAcuerdo({ observaciones }));
  }

  // Método que previene la acción del botón al presionar Enter
  onKeyDown(event: KeyboardEvent): void {
    if (event.key === "Enter") {
      event.preventDefault(); // Previene que Enter ejecute el evento de clic
    }
    return;
  }
  guardarAcuerdo() {
    const acuerdo = this.detalleTema.getRawValue();
    const temas = this.temasAcuerdo.getRawValue().temas;
    this.loadingService.show();
    this.store.dispatch(
      guardarFormulariosAcuerdo({
        acuerdo,
        temas,
        archivos: this.files,
      })
    );
  }
}
